<template>
  <div class="footer">

    <div class="footer-left">
      <div class="routesAndText">
        <div class="routes">
          <ul>
            <li>
              <router-link to="/" @click="topPage()">{{ $t('footer.routes.home') }}</router-link>
            </li>

            <li>
              <router-link to="/about" @click="topPage()">{{ $t('footer.routes.about') }}</router-link>
            </li>

            <li>
              <router-link to="/portfolio" :class="{ active: $route.path.startsWith('/portfolio') }">
                {{ $t('header.routes.portfolio') }}
              </router-link>
            </li>

            <li>
              <router-link to="/team" @click="topPage()">{{ $t('footer.routes.team') }}</router-link>
            </li>

            <li>
              <router-link to="/contact" @click="topPage()">{{ $t('footer.routes.contact') }}</router-link>
            </li>
          </ul>
        </div>



        <p>{{ $t('footer.copyright') }}</p>
      </div>


      <h3>&copy; Blasio Design Studio 2009</h3>
    </div>

    <div class="footer-right">
      <div class="contacts-logo">
        <div class="contacts">
          <div class="contact" v-for="contact in contacts" :key="contact.id">
            <img :src="contact.icon" :alt="contact.alt">
            <p>{{ contact.text }}</p>
          </div>
        </div>
        <router-link to="/">
          <img class="logo" src="/images/blasio_logo.svg" alt="Blasio design építésziroda logoja" @click="topPage()">
        </router-link>
      </div>

      <div class="icons">

        <a v-for="icon in icons" :href="icon.href" target="_blank">
          <img class="footer-icon" :src="icon.src" :alt="icon.alt">
        </a>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref } from 'vue';



const icons = ref([
  {
    "id": 1,
    "src": "/images/icons/epforum.svg",
    "href": "https://epiteszforum.hu/",
    "alt": "Blasio design építészfórum oldala"
  },
  {
    "id": 2,
    "src": "/images/icons/instagram.svg",
    "href": "https://www.instagram.com/",
    "alt": "Blasio design instagram oldala"
  },
  {
    "id": 3,
    "src": "/images/icons/facebook.svg",
    "href": "https://www.facebook.com/",
    "alt": "Blasio design facebook oldala"
  }
])

const contacts = ref([
  {
    "id": 0,
    "text": "+36 70 881 9393",
    "icon": "/images/icons/phone.svg",
    "alt": "A tervező iroda telefonszáma"
  },
  {
    "id": 1,
    "text": "iroda@blasio.hu",
    "icon": "/images/icons/mail.svg",
    "alt": "A tervező iroda e-mail címe"
  },
  {
    "id": 2,
    "text": "2900 Komárom, Klapka György út 20-22.",
    "icon": "/images/icons/location.svg",
    "alt": "A tervező iroda címe"
  }
])



function topPage() {
  window.scrollTo({
    top: 0
  });
}
</script>

<style lang="css" scoped>
.footer {
  width: 100%;
  height: 100%;
  padding: 40px 0;
  background-color: #282828;
  color: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer h3,
p {
  margin: 0;
}

.footer p {
  font-size: 18px;
  max-width: 600px;
}

.footer-left {
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  align-items: start;
  height: 200px;
  padding-left: 100px;
  gap: 36px;

}

.routesAndText {
  display: flex;
  flex-direction: column;
  gap: 36px;

}

.footer-left p {
  font-size: 14px;
}

.routes {
  display: flex;
  justify-content: start;
  align-items: center;
  margin: 0;
}

.routes ul {
  display: flex;
  justify-content: center;
  align-items: center;
  list-style: none;
  gap: 60px;
  padding: 0;
  margin: 0;
}

.routes ul li a {
  text-decoration: none;
  color: #f5f5f5;
  font-size: 16px;
}

.routes ul li a.router-link-exact-active {
  font-weight: 500;
}

.active {
  font-weight: 500;
}

.footer-right {
  display: flex;
  justify-content: space-between;
  align-items: end;
  flex-direction: column;
  height: 200px;
  padding-right: 100px;
}

.contacts-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.contacts {
  display: flex;
  flex-direction: column;
  align-items: start;
  height: auto;
  justify-content: space-between;
  gap: 7px;
}

.contact {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.contact p {
  font-size: 14px;
  margin: 0;
}

.contact img {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  filter: invert(95%);
}

.logo {
  height: 75px;
}

.icons {
  display: flex;
  justify-content: center;
  gap: 40px;
}

.footer-icon {
  width: 35px;
  height: 35px;
  cursor: pointer;
}



@media only screen and (max-width: 1440px) {

  .footer-left {
    height: 140px;
    padding-left: 100px;
  }

  .footer-left p {
    font-size: 12px;
  }

  .footer-right {
    height: 140px;
    padding-right: 80px;
  }

  .contacts-logo {
    gap: 30px;
  }

  .contacts {
    gap: 3px;
  }

  .contact p {
    font-size: 13px;
  }

  .contact img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  .logo {
    height: 60px;
  }

  .icons {
    gap: 30px;
  }

  .footer-icon {
    width: 25px;
    height: 25px;
  }

  .routes ul {
    gap: 40px;
  }

  .routes ul li a {
    font-size: 14px;
  }
}

@media only screen and (max-width: 1300px) {

  .footer {
    height: 100%;
  }


  .footer p {
    max-width: 600px;
  }

  .footer-left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: start;
    height: 200px;
  }

  .footer-left p {
    font-size: 14px;
  }

  .routes ul {
    gap: 40px;
  }

  .routes ul li a {
    font-size: 14px;
  }

  .footer-right {
    display: flex;
    justify-content: space-between;
    align-items: start;
    flex-direction: column;
    gap: 20px;
    height: 200px;
  }

  .contacts-logo {
    display: flex;
    justify-content: center;
    align-items: start;
    flex-direction: column-reverse;
    gap: 20px;
  }

  .contacts {
    display: flex;
    flex-direction: column;
    align-items: start;
    height: auto;
    justify-content: space-between;
  }

  .contact {
    display: inline-flex;
  }

  .contact p {
    font-size: 14px;
    margin: 0;
  }

  .contact img {
    width: 25px;
    height: 25px;
  }

  .logo {
    height: 60px;
  }


}

@media only screen and (max-width: 1100px) {

  .footer p {
    max-width: 350px;
  }

  .routes ul {
    display: block;
  }

  .routes li {
    margin: 5px 0;
  }

  .routesAndText {
    flex-direction: row;
  }

  .routesAndText p {
    padding-right: 48px;
    min-width: 200px;
  }


  .contact {
    margin-bottom: 2px;
  }

}

@media only screen and (max-width: 800px) {
  .footer {
    flex-direction: column-reverse;
    gap: 40px;
  }

  .footer-right {
    height: 100%;
    align-items: end;
    padding: 0;
  }

  .footer-left {
    padding: 0;
    height: 100%;
    gap: 20px;
  }

  .contacts-logo {
    flex-direction: row-reverse;
    gap: 80px;
  }

  .contact img {
    width: 20px;
    height: 20px
  }

  .contact {
    margin: 2px 0
  }

  .routesAndText {
    display: block;
    gap: 40px;
  }

  .routesAndText p {
    min-width: none;
    max-width: 570px;
    padding: 0;
    font-size: 12px;
  }

  .routes ul {
    display: flex;
  }

  .footer-right {
    align-items: start;
    gap: 10px;
  }
}

@media only screen and (max-width: 630px) {

  .contacts-logo {
    display: flex;
    flex-direction: column-reverse;
    gap: 10px;
    align-items: center;
  }

  .footer-right {
    align-items: center;
  }

  /* .logo, .icons {
    padding-left: 20px;
  } */

  .contact p {
    font-size: 12px;
  }

  .routes ul {
    display: block;
  }

  .routes ul li {
    margin: 0;
  }

  .routes ul li a {
    font-size: 12px;
  }

  .footer-left {
    display: flex;
    align-items: center;
  }

  .routesAndText {
    display: flex;
    gap: 20px;
  }

  .routesAndText p {
    max-width: 200px;
    height: 100%;
  }
}
</style>